import { render, staticRenderFns } from "./municipio-form.vue?vue&type=template&id=62fbecf4&scoped=true"
import script from "./municipio-form.vue?vue&type=script&lang=js"
export * from "./municipio-form.vue?vue&type=script&lang=js"
import style0 from "./municipio-form.vue?vue&type=style&index=0&id=62fbecf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbecf4",
  null
  
)

export default component.exports